// extracted by mini-css-extract-plugin
module.exports = {"container":"_2P3DBMCYYRLF6adkIsE_M5","body":"_3OME13Egs15-wXL7lcpV7B","bigHeader":"_344pxIRZIFalyHDwuIbYt0","header":"_2G5gMGlEtxciy7XgtMLzu0","email":"_38KpLHFpEZ2U1w3IkhP3jl"};